import moment from 'moment-timezone';

type PredefinedTimeRangeType =
  | 'TODAY'
  | 'YESTERDAY'
  | 'WEEK'
  | 'LAST_TWO_ENDED_WEEKS';

export const getDatesFromPredefinedTimeRange = (
  range: PredefinedTimeRangeType,
  timezone: string,
  now: Date
): {
  from: Date;
  to: Date;
} => {
  if (range === 'TODAY') {
    const from = moment.tz(now, timezone).startOf('day').toDate();
    return {
      from,
      to: now
    };
  } else if (range === 'YESTERDAY') {
    const to = moment.tz(now, timezone).startOf('day').toDate();
    const from = moment(to).add(-1, 'days').toDate();
    return {
      from,
      to: to
    };
  } else if (range === 'WEEK') {
    const from = moment.tz(now, timezone).startOf('isoWeek').toDate();
    return {
      from,
      to: now
    };
  } else if (range === 'LAST_TWO_ENDED_WEEKS') {
    const to = moment.tz(now, timezone).startOf('isoWeek').toDate();

    const from = moment(to).add(-14, 'days').toDate();

    return {
      from,
      to
    };
  }

  throw new Error(`invalid range: ${range}`);
};

export function getDiffInMinutes(start: Date, end: Date) {
  const duration = moment.duration(moment(end).diff(moment(start)));
  return duration.asMinutes();
}

export function getTimeDiffInSeconds(from: Date, end: Date): number {
  const duration = moment.duration(moment(end).diff(moment(from)));
  return duration.asSeconds();
}

export function getDiffInHours(start: Date, end: Date) {
  const duration = moment.duration(moment(end).diff(moment(start)));
  return duration.asHours();
}
export function getDateTimeListForTimeLine(
  start: Date,
  end: Date,
  stepInMinutes: number
): { position: number; date: Date; minutes: number }[] {
  const result: { position: number; date: Date; minutes: number }[] = [];
  let currentItem = moment(start);
  const lastItem = moment(end);

  if (lastItem.isBefore(currentItem)) {
    return [];
  }

  const totalMinutes = getDiffInMinutes(start, end);

  while (currentItem.isBefore(lastItem)) {
    const currentStep =
      result.length > 0 ? getDiffInMinutes(start, currentItem.toDate()) : 0;
    result.push({
      date: currentItem.toDate(),
      position: (currentStep / totalMinutes) * 100,
      minutes: currentStep
    });
    currentItem = currentItem.add(stepInMinutes, 'minutes');
  }

  result.push({
    date: end,
    position: 100,
    minutes: totalMinutes
  });

  return result;
}

export function getFormattedDates(dates: Date[], format: string): string[] {
  return dates.map((d) => moment(d).format(format));
}

export function getStartDateForTimezone(localDate: Date, timezone: string) {
  const date = `${moment(localDate).local().format('YYYY-MM-DD')} 00:00:00`;
  return moment.tz(date, timezone).toDate();
}
